import { permissions_type } from "./permissions";
import { args_type, response_type, result_type } from "../interfaces";

declare const permissions: permissions_type;
declare const level: string[];
declare const http_request_worker: (
  url: string,
  role: string,
  index: number,
  hostname: string,
  method_id: number,
  datacenter_name: string,
  cluster_name: string | undefined,
  namespace_name: string | undefined,
  body?: string,
  kind?: string,
  old_data?: any[] | undefined,
  no_info?: boolean,
  subscription_id?: string,
  cluster_session?: string,
  workspace_session?: string,
  unit_provide?: string,
  page?: string,
  db_data?: response_type[] | undefined
) => Promise<any>;
declare const close: Function;

export function http_request_func(args: args_type) {
  const {
    url,
    origin,
    method,
    role,
    datacenter_name,
    cluster_name,
    workspace_name,
    body,
    key,
    old_data,
    no_info,
    no_refresh,
    subscription_id,
    cluster_session,
    workspace_session,
    index,
    subscription_id_org,
    unit_provide,
  }: args_type = args;

  const permissions_each: Int32Array = permissions[key];
  let level_found: number = level.indexOf(role);
  if ((level_found > -1 && permissions_each && permissions_each[level_found] > 0) || Array.isArray(role)) {
    let urls: string[] = typeof url === "string" ? [url] : url;
    urls = urls.map((url_each: string) => `${url_each}${subscription_id ? `${key === "subscriptions" ? "&" : "?"}subscriptionId=${subscription_id}` : ""}`);
    const start_request = (db_data?: response_type[]) => {
      try {
        const responses: response_type[] = [],
          urls_for_info: { url: string }[] = [],
          responses_for_info: { [key: string]: response_type } = {},
          promises = urls.map(
            (url: string, index_2: number) =>
              new Promise((resolve: (value?: unknown) => void) => {
                url = url.replace(/_/gi, "");
                const role_new = Array.isArray(role) ? role[index || index_2] : role;
                level_found = level.indexOf(role_new);

                level_found > -1 &&
                  permissions_each &&
                  permissions_each[level_found] > 0 &&
                  http_request_worker(
                    url,
                    role,
                    index || index_2,
                    origin,
                    method,
                    datacenter_name,
                    cluster_name,
                    undefined,
                    body,
                    key,
                    old_data,
                    no_info,
                    subscription_id,
                    cluster_session,
                    workspace_session,
                    unit_provide,
                    undefined,
                    db_data
                  )
                    .then(({ result, original_response }: result_type) => {
                      (result as response_type).index = index_2;
                      responses[index_2] = old_data ? original_response || ({} as response_type) : (result as response_type);
                      if (old_data) {
                        responses_for_info[url] = original_response || ({} as response_type);
                        urls_for_info[index_2] = { url };
                      }
                      postMessage(JSON.stringify([result]));
                      resolve();
                    })
                    .catch(() => {
                      resolve();
                    });
              })
          );
        Promise.all(promises).finally(() => {
          postMessage("done");
          // 如果是 POST, PUT, DELETE, PATCH，需要再更新列表
          if (method > 0 && !no_refresh && !responses.find(({ code }: response_type): boolean | 0 | undefined => code && code >= 400)) {
            if (method > 1) {
              const str: string = urls[0].substring(urls[0].lastIndexOf("/"), urls[0].indexOf("?"));
              urls[0] = urls[0].replace(str, "s");
            } else {
              urls = typeof url === "string" ? [url] : url;
              urls = urls.map(
                (url_each: string) => `${url_each}${subscription_id ? `${key === "subscriptions" ? "&" : "?"}subscriptionId=${subscription_id_org}` : ""}`
              );
              urls[0] = urls[0].replace("?", "s?");
            }
            if (workspace_name) {
              const str: string = urls[0].substr(urls[0].lastIndexOf("/"));
              urls[0] = urls[0].replace(str, `/workspace/${workspace_name}$&`);
            }

            // [urls[0]: string, role: string, index: number, window.location.origin: string, method: number, role: string, cluster_name: string, workspace_name: string, JSON.stringify(body): undefined, key: string]
            http_request_worker(
              urls[0],
              role,
              0,
              origin,
              0,
              datacenter_name,
              cluster_name,
              undefined,
              body,
              key,
              old_data,
              no_info,
              subscription_id_org || subscription_id,
              cluster_session,
              workspace_session,
              unit_provide,
              undefined,
              db_data
            )
              .then(({ result }: result_type) => {
                postMessage(JSON.stringify([result]));
                postMessage("end");
                setTimeout(() => {
                  close();
                }, 0); // 結束 Worker
              })
              .catch(() => {
                postMessage("end");
              });
          } else {
            postMessage("end");
            setTimeout(() => {
              close();
            }, 0); // 結束 Worker
          }
        });
      } catch (err) {
        console.error(err);
      }
    };
      start_request();
  } else if (!method) {
    postMessage(JSON.stringify({ items: [] }));
    postMessage("end");
  }
}
